module.exports = __webpack_public_path__ + "static/media/483c4fd9-f5f4-4482-803b-e7f3145cb0bf.74b8afdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/483c4fd9-f5f4-4482-803b-e7f3145cb0bf.jpg
// module id = 816
// module chunks = 0